import { render, staticRenderFns } from "./EmployeeAvatar.vue?vue&type=template&id=13702c22&scoped=true&"
import script from "./EmployeeAvatar.vue?vue&type=script&lang=js&"
export * from "./EmployeeAvatar.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAvatar.vue?vue&type=style&index=0&id=13702c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13702c22",
  null
  
)

export default component.exports